import { render, staticRenderFns } from "./subscription-plans-list.vue?vue&type=template&id=a2d86552&"
import script from "./subscription-plans-list.vue?vue&type=script&lang=js&"
export * from "./subscription-plans-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports